export const SET_CASE_TOP_LEVELS_COUNT = 'SET_CASE_TOP_LEVELS_COUNT';

export const setCaseTopLevelsCount = (caseId: string, count?: number) =>
  <const>{
    type: SET_CASE_TOP_LEVELS_COUNT,
    payload: { caseId, count }
  };

export type SetCaseTopLevelsCountAction = ReturnType<typeof setCaseTopLevelsCount>;
